import unauthenticatedHttp from "@/services/unauthenticatedHttp";
import { categorizeCommunities } from "@/utils/communitiesUtils";

export async function fetchCommunities() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/communities`
  );

  return data;
}

export async function fetchClassifiedCommunities() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/communities`
  );

  return categorizeCommunities(data);
}

export async function fetchEthicalHackerCommunityUnauth() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/communities`
  );

  return {
    ethicalHackerCommunity: data.find((community: any) => {
      return (
        community.Name?.includes("Ethical Hacker") ||
        community.Name?.includes("Ethical Hacking")
      );
    }),
  };
}

export async function fetchDiscussionThreads(topicId: string, limit?: number) {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/discussion-threads`,
    {
      params: {
        topicId,
        ...(limit && { limit }),
      },
    }
  );

  return data;
}
